import React from "react";

/**
 * @typedef {object} ProgressProps
 * @property {number} currentValue - The current value of the progress bar
 * @property {number} maxValue  - The maximum value of the progress bar
 */

/**
 * Progress component.
 * @param {ProgressProps} props - props
 * @returns {React.ReactElement} React function component
 */
function Progress({ currentValue, maxValue }) {
  if (maxValue < 0) {
    return (
      <div
        className="fr-bg-green-600 fr-h-1.5 fr-mb-4 fr-rounded-full"
        style={{ width: "100%" }}
      />
    );
  }
  const valuePercentage = `${(currentValue / maxValue) * 100}%`;
  return (
    // @ts-ignore
    <div
      className="fr-bg-green-600 fr-h-1.5 fr-mb-4 fr-rounded-full"
      style={{ width: valuePercentage }}
    />
  );
}

export default Progress;
